
import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './services/language';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [RouterOutlet,TranslatePipe],
  selector: 'app-root',
  styleUrl: './app.css',
  templateUrl: './app.html',
})
export class App {

offcanvasOpen = signal(false);

constructor(public languageService: LanguageService){

}

toggleLanguage(): void {
    const current = this.languageService.getLanguage();

    this.languageService.changeLanguage(
      current === 'ar' ? 'en' : 'ar'
    );
  }

toggleOffcanvas(): void {
    this.offcanvasOpen.update(v => !v);
  }

  closeOffcanvas(): void {
    this.offcanvasOpen.set(false);
  }

}
